module.exports = __webpack_public_path__ + "static/media/logotipo.ca28fe67.png";